import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlDirective } from '../../directives/base-control.directive';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss', '../input/input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TextareaComponent), multi: true},
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => TextareaComponent), multi: true},
  ],
})
export class TextareaComponent extends BaseControlDirective implements ControlValueAccessor, OnInit {

  @Input() label;
  @Input() optional = true;
  @Input() invalid;
  @Input() height: number = 150;
  @Input() maxLength: number = 524288;
  @Input() symbolsLeftCounter: boolean;

  @Output() valueChanged: EventEmitter<string> = new EventEmitter();
  @Output() keydownTab: EventEmitter<void> = new EventEmitter();

  @ViewChild('textarea') textarea!: ElementRef;

  constructor(private cdr: ChangeDetectorRef) { super() }

  ngOnInit(): void {
    if(this.autofocus) {
      this.focus();
    }
  }

  isError(): boolean {
    return (this.control.touched && this.control.invalid) || this.invalid || (!this.optional && !this.value);
  }

  onTabKeyDown(ev: Event): void {
    ev.preventDefault();
    this.keydownTab.emit();
  }

  clear(): void {
    event.stopPropagation();
    this.value = '';
    this.valueChanged.emit('');
    this.cdr.detectChanges();
  }

  focus(): void {
    setTimeout(() => {
      this.textarea.nativeElement.focus();
    });
  }

  initInitialValue(value): void {
    this.value = value;
    this.cdr.detectChanges();
  }

}
